if (!customElements.get('fw-video-banner')) {
  customElements.define('fw-video-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      if (!this.video) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.hasAttribute('data-has-poster') && (reducedMotion || navigator.connection?.saveData)) return;
      this.onReady = () => {
        this.loadReady = true;
        this.schedule();
      };
      this.onVisible = () => this.schedule();
      document.addEventListener('visibilitychange', this.onVisible);
      this.interactionEvents = ['pointerdown', 'keydown', 'scroll'];
      this.interactionReady = !window.matchMedia('(max-width: 749px)').matches;
      if (document.documentElement.classList.contains('shopify-design-mode')) this.interactionReady = true;
      this.onInteraction = () => {
        this.interactionReady = true;
        this.interactionEvents.forEach(event => document.removeEventListener(event, this.onInteraction));
        this.schedule();
      };
      if (!this.interactionReady) {
        this.interactionEvents.forEach(event => document.addEventListener(event, this.onInteraction, {passive: true}));
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.nearViewport = entries.some(entry => entry.isIntersecting);
          this.schedule();
        }, {rootMargin: '100px'});
        this.observer.observe(this);
      } else {
        this.nearViewport = true;
      }
      if (document.readyState === 'complete') this.onReady();
      else window.addEventListener('load', this.onReady, {once: true});
    }

    async schedule() {
      if (this.scheduled || this.started || !this.loadReady || !this.nearViewport || !this.interactionReady || document.hidden) return;
      this.scheduled = true;
      const poster = this.querySelector('img');
      if (poster) {
        try { await poster.decode(); } catch {}
      }
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const start = () => {
          this.scheduled = false;
          if (document.hidden) return;
          this.started = true;
          this.video.addEventListener('playing', () => this.setAttribute('data-playing', ''), {once: true});
          this.video.src = window.matchMedia('(max-width: 749px)').matches
            ? this.video.dataset.mobileSrc : this.video.dataset.src;
          if (this.dataset.autoplay === 'true') this.video.play().catch(() => {});
          else {
            this.video.addEventListener('loadeddata', () => this.setAttribute('data-playing', ''), {once: true});
            this.video.load();
          }
          this.observer?.disconnect();
        };
        if ('requestIdleCallback' in window) this.idleId = requestIdleCallback(start, {timeout: 1500});
        else this.idleId = setTimeout(start, 0);
      }));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('load', this.onReady);
      document.removeEventListener('visibilitychange', this.onVisible);
      this.interactionEvents?.forEach(event => document.removeEventListener(event, this.onInteraction));
      if ('cancelIdleCallback' in window) cancelIdleCallback(this.idleId);
      else clearTimeout(this.idleId);
    }
  });
}
